import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/GPSMedia/Form.tsx
var GPSMediaFieldForm = ({ config }) => {
	return /* @__PURE__ */ jsx("div", { children: "todo" });
};
//#endregion
export { GPSMediaFieldForm };

//# sourceMappingURL=Form.js.map